import { combineReducers } from 'redux';
import userReducer from './user';
import wpArticlesReducer from './wpArticles';

const rootReducer = combineReducers({
  user: userReducer,
  wpArticles: wpArticlesReducer,
});

export default rootReducer;
